import { useNavigate } from "react-router-dom";
import { config } from "../Environment";
import { useEffectOnce } from "../hooks/useEffectOnce";
import useRetryFetch from "../hooks/useRetryFetch";
import { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import LoggerContext from "../context/LoggerProvider";
import useAuth from "../hooks/useAuth";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "./ui/card";
import { PageLoader } from "./ui/page-loader";
import { Spinner } from "./ui/spinner";

function EntryPortal() {
  const navigate = useNavigate();
  const retryFetch = useRetryFetch();
  const { auth } = useAuth();
  const { Logger } = useContext(LoggerContext);
  const { t } = useTranslation();
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    if (auth?.email) {
      setAuthenticated(true);
      setTimeout(() => {
        navigate("/portal");
      }, 1000);
    } else {
      // Redirect unauthenticated users to marketplace after 3 seconds
      setTimeout(() => {
        navigate("/marketplace");
      }, 3000);
    }
  }, []);

  function renderAuthenticated() {
    return (
        <PageLoader fullScreen />
    );
  }

  function renderNotAuthenticated() {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/5 to-purple-50">
        <Card className="w-full max-w-md mx-4">
          <CardHeader className="text-center">
            <div className="mx-auto mb-4 w-16 h-16 bg-gradient-to-br from-primary to-purple-600 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </div>
            <CardTitle className="text-2xl font-bold">Thank You for Visiting!</CardTitle>
            <CardDescription className="text-base mt-2">
              Redirecting you to explore our marketplace...
            </CardDescription>
          </CardHeader>
          <CardContent className="text-center pb-6">
            <div className="flex justify-center my-4">
              <Spinner size="md" />
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              Discover ready-made activities, expert services, and learning bundles
            </p>
            <button
              onClick={() => navigate("/marketplace")}
              className="text-primary hover:underline text-sm font-medium"
            >
              Go to Marketplace now →
            </button>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (authenticated) {
    return renderAuthenticated();
  } else {
    return renderNotAuthenticated();
  }
}

export default EntryPortal;
